// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"8b0778ee","553":"65a74a4d","977":"8b421097"}[chunkId] + ".chunk.js";
};